import React, { useEffect, useState } from "react";
import axios from "axios";
import { DASHBOARD_CLIENT_DETAIL_EQUITY } from "../../../Configuration/API_URL";
import { numDifferentiation } from "../../../CommonMethhods/CovertRupees";
import { Modal } from "react-bootstrap";
import Loader from "../../Common/Loader";
import { Constants } from "../../../CommonMethhods/Constants";
import SmallLoader from "../../Common/smallLoader";
import {
  AESEncryption,
  ApiResDecrypt,
  noDataFound,
} from "../../../CommonMethhods/CommonMethods";

function TradingTransactionNew() {
  const storeToken = localStorage.getItem("ssoToken");
  const [tableData, setTableData] = useState([]);
  const [modalTableData, setModalTableData] = useState([]);
  const [loader, setLoader] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [page, setPage] = useState(1);
  const [serverError, setServerError] = useState("");
  const [scrollLoader, setScrollLoader] = useState(false);
  const [count, setCount] = useState();
  const [pdfLoader, setPdfLoader] = useState(false);
  const [excelLoader, setExcelLoader] = useState(false);
  const [modalLoader, setModalLoader] = useState(false);

  const tradingTransactionData = async (fileView = "grid", pageSize) => {
    if (page === 1 && fileView === "grid") {
      setLoader(true);
    }
    if (page === 1 && fileView === "grid" && showModal) {
      setModalLoader(true);
    }
    if (fileView === "pdf") {
      setPdfLoader(true);
    }
    if (fileView === "excel") {
      setExcelLoader(true);
    }
    let payloadValue = {
      clientCode: localStorage.getItem("clientCode"),
      duration: "yearly",
      pageNo: page,
      pageSize: pageSize,
      fileType: fileView,
    };
    let encPayload = AESEncryption(payloadValue);
    try {
      const transactionsData = await axios.post(
        DASHBOARD_CLIENT_DETAIL_EQUITY.TradingTransactions_URL,

        `"${encPayload}"`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${storeToken}`,
            reserv: 1,
          },
        }
      );
      const resData = ApiResDecrypt(transactionsData?.data);
      setCount(resData?.count);
      if (resData?.status === 0) {
        if (fileView === "grid") {
          if (page > 1) {
            setModalTableData((prev) => {
              return [...prev, ...resData?.data?.transactionDetails];
            });
          } else {
            setModalTableData(resData?.data?.transactionDetails);
          }
          if (!showModal) {
            setTableData(resData?.data?.transactionDetails);
          }
        } else if (fileView === "excel") {
          window.open(resData?.data, "_self", "noopener,noreferrer");
        } else if (fileView === "pdf") {
          window.open(resData?.data, "_blank", "noopener,noreferrer");
        }
      }
    } catch (error) {
      console.log(error);
      setServerError(error.message);
    } finally {
      setLoader(false);
      setScrollLoader(false);
      setExcelLoader(false);
      setPdfLoader(false);
      setModalLoader(false);
    }
  };
  const handleScroll = (e) => {
    const a = e.target;
    if (a.scrollTop + a.offsetHeight + 1 >= a.scrollHeight && !scrollLoader) {
      if (!(count <= 10 * page)) {
        setScrollLoader(true);
        setPage((prev) => prev + 1);
      }
    }
  };
  const handleViewClick = () => {
    setShowModal(true);

    tradingTransactionData("grid", 10);
  };

  useEffect(() => {
    tradingTransactionData("grid", 10);
  }, [page]);

  const onHide = () => {
    setShowModal(false);
    setPage(1);
  };

  const handleOnClick = (e) => {
    tradingTransactionData(e.target.value, -1);
  };
  return (
    <>
      <div className="card-box transactions bottom-25">
        <div className="transactions__header card-title">
          <div className="figure-inlac">
            <h2 className="small-title">{Constants.Trading_Transactions}</h2>
            {/* <p>{Constants.Figure_In_Lacs_for_all}</p> */}
          </div>

          {tableData && tableData.length > 0 ? (
            <div>
              <button className="view-more" onClick={handleViewClick}>
                {Constants.View_All}
              </button>
            </div>
          ) : (
            ""
          )}
        </div>

        {loader ? (
          <div className="loader-alignment">
            <Loader />
          </div>
        ) : (
          <div className="transactions__right scroll-table">
            {tableData && tableData?.length > 0 ? (
              <table className="table ">
                <thead>
                  <tr>
                    <th scope="col">{Constants.Trade_Date}</th>
                    <th scope="col">{Constants.Scrip_Name}</th>
                    <th scope="col">{Constants.Exchange}</th>
                    <th scope="col">{Constants.Traded_Type}</th>
                    <th scope="col">{Constants.Buy_Qty}</th>
                    <th scope="col">{Constants.Buy_Avg_Rate}</th>
                    <th scope="col">{Constants.Buy_Amount}</th>
                    <th scope="col">{Constants.Sell_Qty}</th>
                    <th scope="col">{Constants.Sell_Avg_Rate}</th>
                    <th scope="col">{Constants.Sell_Amount}</th>
                    <th scope="col">{Constants.Net_Qty}</th>
                    <th scope="col">{Constants.Net_Avg_Rate}</th>
                    <th scope="col">{Constants.Net_Amount}</th>
                  </tr>
                </thead>
                <tbody>
                  {tableData.length > 0 &&
                    tableData.map((info, key) => {
                      return (
                        <tr key={key}>
                          <td>{info?.tradeDate || "-"}</td>
                          <td>{info?.scripName || "-"}</td>
                          <td>{info?.exchange || "-"}</td>
                          <td>{info?.trdType || "-"}</td>
                          <td>{info?.buyQty || 0}</td>
                          <td>{info?.buyAvgRate || 0}</td>
                          <td>
                            {info?.buyAmount
                              ? numDifferentiation(info?.buyAmount)
                              : 0}
                          </td>
                          <td>{info?.sellQty || 0}</td>
                          <td>{info?.sellAvgRate || 0}</td>
                          <td>
                            {info?.sellAmount
                              ? numDifferentiation(info?.sellAmount)
                              : 0}
                          </td>
                          <td>{info?.netQty || 0}</td>
                          <td>{info?.netAvgRate || 0}</td>
                          <td>
                            {info?.netAmt
                              ? numDifferentiation(info?.netAmt)
                              : 0}
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            ) : serverError ===
              "Something went wrong, Please try again later." ? (
              <h4 className="no-data">{serverError}</h4>
            ) : (
              noDataFound()
            )}
          </div>
        )}

        <Modal
          show={showModal}
          // onHide={() => setShowModal(false)
          // }
          onHide={onHide}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          className="trading-transaction-model setting-model"
          backdrop="static"
          keyboard={false}
        >
          <Modal.Header className="mb-4 modal-header">
            <Modal.Title id="contained-modal-title-vcenter modal-title">
              <h2 className="h2-css-all">{Constants.Trading_Transactions}</h2>
            </Modal.Title>
            <div className="btn-wrapper-summary">
              <button
                value="excel"
                onClick={handleOnClick}
                className="summary-btn excel-btn"
              >
                {excelLoader ? (
                  <div>
                    <SmallLoader />
                  </div>
                ) : (
                  <>
                    <span className="icon-excelsvg"></span>
                    Excel
                  </>
                )}
              </button>
              <button
                className="summary-btn pdf-btn"
                value="pdf"
                onClick={handleOnClick}
              >
                {pdfLoader ? (
                  <div>
                    <SmallLoader />
                  </div>
                ) : (
                  <>
                    <span className="icon-pdfsvg"></span>
                    PDF
                  </>
                )}
              </button>
              <button
                type="button"
                className="btn-close"
                aria-label="Close"
                onClick={onHide}
              >
                <span className="icon-close"></span>
              </button>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="table-responsive scroll-table model-top-active-table">
              {modalLoader ? (
                <div className="loader-alignment">
                  <Loader />
                </div>
              ) : (
                <table className="table">
                  <thead>
                    <tr>
                      <th scope="col">{Constants.Trade_Date}</th>
                      <th scope="col">{Constants.Scrip_Name}</th>
                      <th scope="col">{Constants.Exchange}</th>
                      <th scope="col">{Constants.Traded_Type}</th>
                      <th scope="col">{Constants.Buy_Qty}</th>
                      <th scope="col">{Constants.Buy_Avg_Rate}</th>
                      <th scope="col">{Constants.Buy_Amount}</th>
                      <th scope="col">{Constants.Sell_Qty}</th>
                      <th scope="col">{Constants.Sell_Avg_Rate}</th>
                      <th scope="col">{Constants.Sell_Amount}</th>
                      <th scope="col">{Constants.Net_Qty}</th>
                      <th scope="col">{Constants.Net_Avg_Rate}</th>
                      <th scope="col">{Constants.Net_Amount}</th>
                    </tr>
                  </thead>
                  <tbody onScroll={(e) => handleScroll(e)}>
                    {modalTableData &&
                      modalTableData.map((info, key) => {
                        return (
                          <tr key={key}>
                            <td>{info?.tradeDate || "-"}</td>
                            <td>{info?.scripName || "-"}</td>
                            <td>{info?.exchange || "-"}</td>
                            <td>{info?.trdType || "-"}</td>
                            <td>{info?.buyQty || 0}</td>
                            <td>{info?.buyAvgRate || 0}</td>
                            <td>
                              {info?.buyAmount
                                ? numDifferentiation(info?.buyAmount)
                                : 0}
                            </td>
                            <td>{info?.sellQty || 0}</td>
                            <td>{info?.sellAvgRate || 0}</td>
                            <td>
                              {info?.sellAmount
                                ? numDifferentiation(info?.sellAmount)
                                : 0}
                            </td>
                            <td>{info?.netQty || 0}</td>
                            <td>{info?.netAvgRate || 0}</td>
                            <td>
                              {info?.netAmt
                                ? numDifferentiation(info?.netAmt)
                                : 0}
                            </td>
                          </tr>
                        );
                      })}
                  </tbody>
                </table>
              )}
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
export default TradingTransactionNew;
